import React from 'react';
import { MessageSquare, Ruler, FileCheck, Hammer, Home, ArrowRight } from 'lucide-react';
import { projectStages } from '../mock';

const iconMap = {
  MessageSquare,
  Ruler,
  FileCheck,
  Hammer,
  Home
};

const Process = () => {
  return (
    <section id="process" className="py-20 bg-gradient-to-br from-[#faf8f5] to-[#f5f5f0]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-[#c9a961]/10 text-[#c9a961] rounded-full text-sm font-semibold">
              Our Process
            </span>
          </div>
          
          <h2
            className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Your Journey to the{' '}
            <span className="text-[#c9a961]">Perfect Home</span>
          </h2>
          
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our structured 5-stage process ensures transparency, quality, and peace of mind at every step. With advanced project management systems, you'll have real-time visibility into your project's progress.
          </p>
        </div>

        {/* Process Timeline */}
        <div className="relative">
          {/* Timeline Line - Desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-300 -translate-y-1/2" style={{ top: '80px' }}></div>

          {/* Process Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 relative">
            {projectStages.map((stage, index) => {
              const Icon = iconMap[stage.icon];
              return (
                <div key={stage.id} className="relative">
                  {/* Card */}
                  <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 relative z-10">
                    {/* Stage Number */}
                    <div className="absolute -top-4 -right-4 h-12 w-12 bg-[#c9a961] text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                      {stage.id}
                    </div>

                    {/* Icon */}
                    <div className="h-16 w-16 bg-gradient-to-br from-[#c9a961]/20 to-[#c9a961]/5 rounded-xl flex items-center justify-center mb-4">
                      <Icon className="h-8 w-8 text-[#c9a961]" />
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {stage.title}
                    </h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {stage.description}
                    </p>
                    <div className="inline-flex items-center gap-2 text-sm font-semibold text-[#c9a961]">
                      <span>{stage.duration}</span>
                    </div>
                  </div>

                  {/* Arrow - Desktop */}
                  {index < projectStages.length - 1 && (
                    <div className="hidden lg:block absolute top-[80px] -right-4 z-20">
                      <ArrowRight className="h-8 w-8 text-[#c9a961]" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white rounded-2xl shadow-lg p-8 max-w-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Transparent Project Management
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Our proprietary systems provide automated progress reporting and real-time updates throughout every stage, ensuring you're always informed and confident in your investment.
            </p>
            <div className="flex items-center justify-center gap-2 text-[#c9a961] font-semibold">
              <FileCheck className="h-5 w-5" />
              <span>Automated Monitoring & Reporting</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;